import React from 'react';
import { FaFacebookSquare } from 'react-icons/fa';
import { PropTypes } from 'prop-types';

export default function FacebookLoginButton({ user, login }) {
    if (user != null) {
        return <div>
            <div><b>{user.displayName}</b>, welcome back</div>
            <button className="btn btn-link" onClick={() => {
                firebase.auth().signOut()
            }}>Sign out</button>
        </div>
    } else {
        return <button
            className="mainpg-btn mainpg-btn-facebook"
            onClick={() => {
                var provider = new firebase.auth.FacebookAuthProvider();
                
                firebase.auth().signInWithPopup(provider).then((result)=>{
                    login(result.user)
                }).catch(function (error) {});
            }}>
            <span style={{ fontSize: "16px" }}><FaFacebookSquare /> Continue with Facebook</span>
        </button>
    }
}
